import React from 'react';
import HeaderAppBar from './header';
import { Container, Box, Typography } from '@material-ui/core';


export default function AppAbout(props) {
  const appName = require('../../package.json').name
  const appDescription = require('../../package.json').description
  const appVersion = require('../../package.json').version
  return (
    <div>
    <HeaderAppBar />

    <Container maxWidth="sm">

      <Box pt={10}>
          <Typography variant="h4" component="h1">
          Sobre o monitor de impressão
          </Typography>

          <Typography >
          Desenvolvido por Parseint Desenvolvimento de Sistemas
          </Typography>
      </Box>

      <div>
        <b>Nome:</b> {appName} - {appDescription}<br/>
        <b>Versão:</b> {appVersion}<br/>
      </div>

    </Container>
    </div>
  );
}
